import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

export default function BarItem({ name,
    value,
    barHeight,
    barWidth,
    radius=10,
    x,
    y,
    fill,
    stroke,
    opacity=1,
    onHover,
    onLeave 
}){
    const barRef = useRef();
    const valueRef = useRef();
    const nameRef = useRef();

    useEffect(() => {
      const transition = d3.transition().duration(800);

      d3.select(barRef.current)
        .transition(transition)
        .attr('y', y)
        .attr('width', barWidth);

      d3.select(valueRef.current)
        .transition(transition)
        .attr('x', barWidth - 7)
        .attr('y', y + barHeight / 2)
        .style('opacity', barWidth > 80 ? 1 : 0);

      d3.select(nameRef.current)
        .transition(transition)
        .attr('y', y + barHeight / 2);
    }, [barWidth, y, barHeight]);

    return (
      <g
        onMouseEnter={onHover}
        onMouseLeave={onLeave}
        style={{transition:'opacity 250ms cubic-bezier(0.075, 0.82, 0.165, 1)'}}
        opacity={opacity}
      >
        <defs>
            <linearGradient id={`gradient-${name}`} x1='0%' y1='0%' x2='100%' y2='0%'>
                <stop offset="0%" stopColor={fill} stopOpacity=".8"/>
                <stop offset="100%" stopColor={fill} stopOpacity="1"/>
            </linearGradient>
        </defs>
        <rect
            ref={barRef}
            x={x}
            y={y}
            width={0}
            height={barHeight}
            opacity={1}
            stroke={stroke}
            fill={`url(#gradient-${name})`}
            fillOpacity={1}
            strokeWidth={1}
            rx={radius}
            ry={radius}
        />
        <text
          ref={nameRef}
          x={ x + 10}
          y={y + barHeight / 2}
          textAnchor="start"
          alignmentBaseline="central"
          fontSize={12}
          fill="white"
          fontWeight="bold"
        >
            {name + " " + value}
        </text>
      </g>
    );
};